<template>
  <div class="crumb">
    <template v-for="(menu, index) in parentMenus">
      <span v-if="menu.isLink" :class="{'home': index === 0}" style="cursor: pointer;" :key="'menuName'+index"
            @click="$router.push({path: menu.path, query: menu.query})">
        {{menu.name}} /
        <span v-if="index < parentMenus.length - 1">/</span>
      </span>
      <span v-else :class="{'home': index === 0}" :key="'menuName'+index">
        {{menu.name}} /
        <span v-if="index < parentMenus.length - 1">/</span>
      </span>
    </template>
    <span>{{matchMenu ? matchMenu.name : ''}}</span>
    <span class="tip" v-if="menuTip"><i class="el-icon-question"
                                        style="color: rgb(0, 152, 153); margin-right: 5px;"></i>{{menuTip}}</span>
  </div>
</template>

<script>
  export default {
    name: "Bread-Crumb",
    props: {
      menuEnums: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        matchMenu: {},
        parentMenus: []
      }
    },
    beforeMount() {
      this.resetBreadCrumb({path: this.$route.path, query: this.$route.query})
    },
    computed: {
      menuTip() {
        return this.matchMenu.tip || '';
      }
    },
    methods: {
      isObjectValueEqual(a, b) {
        let aProps = Object.getOwnPropertyNames(a);
        let bProps = Object.getOwnPropertyNames(b);

        if (aProps.length != bProps.length) {
          return false;
        }

        for (let i = 0; i < aProps.length; i++) {
          let propName = aProps[i];

          if (a[propName].toString() !== b[propName].toString()) {
            return false;
          }
        }

        return true;
      },
      // 根据key数组，获取只包含key键值对的对象
      getMatchedObj(originObj = {}, keysArr = []) {
        let resObj = {}
        keysArr.forEach(key => {
          if (originObj.hasOwnProperty(key)) {
            resObj[key] = originObj[key]
          }
        })
        return resObj
      },
      matchMenuByPath({menu = [], path = '', query = {}}) {
        let arr = []
        for (let i = 0, length = menu.length; i < length; i++) {
          if (menu[i].path === path) {
            console.log(Object.assign({}, menu[i].query))
            console.log(Object.assign({}, query))
            if (!menu[i].query) {
              // 没有query说明完全匹配，直接返回
              arr.push(menu[i])
              return arr
            }
            // query完全相同，则匹配成功
            else if (query && this.isObjectValueEqual(Object.assign({}, menu[i].query), Object.assign({}, query))) {
              return menu[i]
            }
            // query可能不完全相同，但满足匹配规则，匹配也成功
            else if (query && this.isObjectValueEqual(Object.assign({}, this.getMatchedObj(menu[i].query, menu[i].match ? menu[i].match.keys || [] : [])), Object.assign({}, this.getMatchedObj(query, menu[i].match ? menu[i].match.keys || [] : [])))) {
              return menu[i].match
            }
          } else if (menu[i].children) {
            // 如果有子级，把当前菜单记录进去（因为需要记录路径）
            arr.push(menu[i])
            let resArr = []
            // 递归找子级
            resArr.push(this.matchMenuByPath({menu: menu[i].children, path, query}) || {})
            arr.push(resArr[0])
            return arr
          }
        }
      },
      match({menuArr, parent, query}) {
        for (let i = 0, length = menuArr.length; i < length; i++) {
          if(menuArr[i].path === this.$route.path){
            if (!menuArr[i].query) {
              // 没有query说明完全匹配，直接返回
              this.matchMenu = menuArr[i]
              break
            }
            // query完全相同，则匹配成功
            if (query && this.isObjectValueEqual(Object.assign({}, menuArr[i].query), Object.assign({}, query))) {
              this.matchMenu = menuArr[i]
              if(parent){
                this.parentMenus.push(parent)
              } else {
                this.parentMenus.push(menuArr[i])
              }
              break
            }
            // query可能不完全相同，但满足匹配规则，匹配也成功
            else if (query && this.isObjectValueEqual(Object.assign({}, this.getMatchedObj(menuArr[i].query, menuArr[i].match ? menuArr[i].match.keys || [] : [])), Object.assign({}, this.getMatchedObj(query, menuArr[i].match ? menuArr[i].match.keys || [] : [])))) {
              this.matchMenu = menuArr[i].match
              if(parent){
                this.parentMenus.push(parent)
              } else {
                this.parentMenus.push(menuArr[i])
              }
              break
            }
          }
          if (menuArr[i].children) {
            this.match({menuArr:menuArr[i].children, parent:menuArr[i], query})
          }
        }
      },
      resetBreadCrumb({path, query}) {
        this.matchMenu = {}
        this.parentMenus = []
        this.match({menuArr: this.menuEnums, query: query})
      }
    },
    watch: {
      $route: {
        handler(val) {
          this.resetBreadCrumb({path: val.path, query: val.query})
        },
        deep: true
      }
    }
  }
</script>

<style lang="less" scoped>
  .crumb {
    font-size: 18px;
    .home {
      color: #000;
    }
    .tip {
      margin-left: 20px;
      font-size: 14px;
      color: #646464;
    }
  }
</style>



// WEBPACK FOOTER //
// components/corp-comps/Bread-Crumb.vue